import { fontClasses, FontProps, FONT_COLOR } from '../font-props';
import './font-body4.scss';
import '../font.scss';

const FontBody4: React.FC<FontProps> = (props): JSX.Element => {
    props = {
        ...props,
        color: typeof props.color === "undefined" ? FONT_COLOR.NEUTRAL3 : props.color
    };

    return (
        <span className={`font font-body4 ${fontClasses(props)}`}>{props.children}</span>
    )
};

export default FontBody4;
